/**
 * TanStack Query hooks for `bulk-import-lost-orders`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	bulkImportLostOrdersQueryKeys,
	type CreateBulkImportLostOrdersBody,
	type ListBulkImportLostOrdersResponse,
	type BulkImportLostOrdersRow,
} from "./api";

export function useBulkImportLostOrdersList(): UseQueryResult<ListBulkImportLostOrdersResponse, Error> {
	return useQuery({
		queryKey: bulkImportLostOrdersQueryKeys.list(),
		queryFn: list,
	});
}

export function useBulkImportLostOrdersCreate(): UseMutationResult<BulkImportLostOrdersRow, Error, CreateBulkImportLostOrdersBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: bulkImportLostOrdersQueryKeys.all });
		},
	});
}

export function useBulkImportLostOrdersDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: bulkImportLostOrdersQueryKeys.all });
		},
	});
}
